export default __webpack_public_path__ + "static/media/colored_lion_1.d44dcfcd.jpg";